<div [formGroup]="form">
  <div class="field grid">
    <label class="col-fixed">Email sending mechanism</label>
    <div class="col-fixed inputfield">
      <input type="text" readonly pInputText value="SMTP" class="displayOnly form-control" />
    </div>
  </div>
  <div class="field grid">
    <label class="col-fixed">SMTP Host</label>
    <div class="col-fixed inputfield">
      <input type="text" readonly pInputText id="host" formControlName="host" class="displayOnly form-control" />
    </div>
  </div>
  <div class="field grid">
    <label class="col-fixed">SMTP Port</label>
    <div class="col-fixed inputfield">
      <input type="text" readonly pInputText id="port" formControlName="port" class="displayOnly form-control" />
    </div>
  </div>
  <div class="field grid">
    <label class="col-fixed">Username</label>
    <div class="col-fixed inputfield">
      <input type="text" readonly pInputText id="username" formControlName="username" class="displayOnly form-control" />
    </div>
  </div>
  <div class="field grid">
    <label class="col-fixed">Password</label>
    <div class="col-fixed inputfield">
      <input type="text" readonly pInputText value="************" class="displayOnly form-control" />
    </div>
  </div>
</div>
